module.exports = __webpack_public_path__ + "assets/img/00088.b480f7c2.png";